import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ContactTypeService } from '../../../../core/services/contact/contact-type/contact-type.service'

@Component({
  selector: 'contact-client-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './contact-client-form.component.html',
  styleUrl: './contact-client-form.component.scss',
  providers: [ContactTypeService],
  standalone: true,
})
export class ContactClientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private contactTypeService: ContactTypeService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() optional = false

  listType: any[] = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.contactTypeService.listContactType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('description')?.setValue(this.editItem.descricao)
    this.form.get('typeContact')?.setValue(this.editItem.tipoContatoId)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    const req = this.optional ? [] : [Validators.required]
    this.form = this.formBuilder.group({
      description: ['', req],
      typeContact: ['', req],
    })
  }

  getTypeDescription() {
    const typeId = this.form.get('typeContact')?.value
    if (typeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === typeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        descricao: this.form.controls['description'].value,
        tipoContatoId: this.form.controls['typeContact'].value,
        tipoContato: this.getTypeDescription(),
      }
    } else {
      return {
        tipoContato: this.getTypeDescription(),
        descricao: this.form.controls['description'].value,
        tipoContatoId: this.form.controls['typeContact'].value,
      }
    }
  }
}
